const demoSamples = [
    {
    id: "modern-architecture",
    title: "Modern Architecture",
    description: "A visually stunning showcase of architectural marvels with immersive image displays and interactive elements.",
    features: [
      "Responsive image galleries with modal viewing experience",
      "Interactive timeline for exploring architectural history",
      "Newsletter subscription with form validation",
      "Dynamic content cards with expandable details"
    ],
    filename: "Modern_Architecture.html"
  },
  {
    id: "admin-dashboard",
    title: "DevOps Monitoring Dashboard",
    description: "An administrative interface for monitoring activities, managing tasks, and tracking processes with real-time analytics.",
    features: [
      "Multi-section navigation for Activities, Tasks, and Processes",
      "Advanced search and filtering capabilities for activity monitoring",
      "Real-time processing capacity charts with Chart.js integration",
      "Interactive task management with status indicators and assignments"
    ],
    filename: "Admin_Dashboard.html"
  },
    {
    id: "movie-script",
    title: "Movie Script Editor",
    description: "An interactive script editing interface that helps screenwriters refine dialogue and improve their scripts using AI suggestions.",
    features: [
      "Real-time AI script suggestions with multiple alternatives",
      "Interactive highlighting for navigation between editable segments",
      "Seamless user interface for accepting or rejecting changes",
      "Context-aware explanation for each suggested improvement"
    ],
    filename: "Movie_Script_Editor.html"
  },
  {
    id: "crop-tracker",
    title: "Crop Tracker Dashboard",
    description: "A comprehensive agricultural monitoring dashboard with data visualization and real-time analytics.",
    features: [
      "Interactive data charts for monitoring crop growth metrics",
      "Real-time field health mapping with sensor integration",
      "AI-powered recommendations based on environmental data",
      "Customizable dashboard with filterable metrics and historical comparisons"
    ],
    filename: "Crop_Tracker.html"
  },
    {
    id: "horse-stables",
    title: "Horse Stables Catalog",
    description: "A premium horse breeding catalog showcasing purebred horses with detailed profiles and availability status.",
    features: [
      "Interactive search and filtering by horse attributes",
      "Dynamic status badges for availability tracking",
      "Responsive card-based layout with hover animations",
      "Mobile-friendly navigation with hamburger menu"
    ],
    filename: "Horse_List.html"
  }
];

export default demoSamples;